import Image from 'next/image';
import React from 'react';

import Button from '@/components/common/Button/Button';
import { Modal } from '@/components/common/Modal/Modal';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
}

export const BackModal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  onContinue,
}: ModalProps) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => onClose()}
      headerTitle={''}
      customContentStyles={{ maxWidth: '398px' }}
      hideCloseIcon={true}
    >
      <div className="mx-auto w-auto max-w-sm p-8 lg:max-w-xs">
        <div className="flex w-full flex-col bg-white">
          <div className="mb-6 flex justify-center">
            <Image
              id="back"
              src="/assets/icons/warning.svg"
              alt="warning"
              width={40}
              height={40}
            />
          </div>
          <span className="text-balance pb-6 text-center font-interMedium text-base text-black">
            If you go back, your meal plan will be reset, and you&apos;ll need
            to start again.
          </span>
          <span className="text-balance pb-6 text-center font-interMedium text-base text-black">
            Are you sure you want to continue?
          </span>
          <div className="flex w-full flex-col items-stretch justify-center space-y-4">
            <Button theme="primary" type="button" onClick={onClose}>
              <span className="">No, keep my plan</span>
            </Button>
            <Button theme="link" type="button" onClick={onContinue}>
              <span className="text-error">Yes, reset my plan</span>
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
